import { render } from "./profileIcon.svg?vue&type=template&id=57bfeb50"
const script = {}
script.render = render

export default script